export default "__VITE_ASSET__CdZPBd61__"